import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UserInfo } from '../../../models/user-info.model';
import { MatDialog } from '@angular/material/dialog';
import { GraphService } from 'src/app/services/graph/graph.service';
import { Router } from '@angular/router';
import { CreateDialogComponent } from './create-dialog/create-dialog.component';
import { UsersService } from 'src/app/services/users/users.service';
import { entAnimations } from 'src/app/animations';
import { lastValueFrom } from 'rxjs';
import { UserListfields } from 'src/app/models/user-list-fields.model';
import { Error } from 'src/app/models/error.model';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html',
  styleUrls: ['./user-create.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: entAnimations,
  standalone: false,
})
export class UserCreateComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  isLoading = false;
  private currentUser: UserInfo;
  hasNoDemands = false;
  private demands: UserListfields[] = [];
  isErrorGetUsersDemands = false;
  errorGetUsersDemands: Error = { error: { message: '', code: '' } };

  dataSource: MatTableDataSource<UserListfields>;
  displayedColumns: string[] = [];
  expandedElement: UserListfields | null;
  windowWidth: number = window.innerWidth;
  sortedValue: string;

  constructor(
    private _router: Router,
    private _matDialog: MatDialog,
    private _graphService: GraphService,
    _userService: UsersService
  ) {
    this.currentUser = _userService.currentUserValue;
    this.getListofUsersDemand();
  }

  ngOnInit(): void {
    this.updateDisplayedColumns();
  }

  @HostListener('window:resize')
  onResize(): void {
    this.windowWidth = window.innerWidth;
    this.updateDisplayedColumns();
  }

  private updateDisplayedColumns(): void {
    if (this.windowWidth >= 1500) {
      this.displayedColumns = [
        'status',
        'firstname',
        'lastname',
        'gender',
        'phone',
        'address',
        'npa',
        'locality',
        'expand',
      ];
    } else if (this.windowWidth < 1500 && this.windowWidth >= 1300) {
      this.displayedColumns = [
        'status',
        'firstname',
        'lastname',
        'gender',
        'address',
        'npa',
        'locality',
        'expand',
      ];
    } else if (this.windowWidth < 1300 && this.windowWidth >= 1100) {
      this.displayedColumns = [
        'status',
        'firstname',
        'lastname',
        'gender',
        'npa',
        'locality',
        'expand',
      ];
    } else if (this.windowWidth < 1100 && this.windowWidth >= 900) {
      this.displayedColumns = [
        'status',
        'firstname',
        'lastname',
        'gender',
        'locality',
        'expand',
      ];
    } else if (this.windowWidth < 900 && this.windowWidth >= 500) {
      this.displayedColumns = [
        'status',
        'firstname',
        'lastname',
        'gender',
        'expand',
      ];
    } else {
      this.displayedColumns = ['status', 'firstname', 'lastname', 'expand'];
    }
  }

  openAddUserdialog(): void {
    const dialogRef = this._matDialog.open(CreateDialogComponent, {
      panelClass: 'app-create-dialog',
      data: {
        action: 'new',
        currentUser: this.currentUser,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe(() => {
      this.getListofUsersDemand();
    });
  }

  private async getListofUsersDemand(): Promise<void> {
    try {
      this.hasNoDemands = false;
      this.isLoading = true;
      this.demands = await lastValueFrom(
        this._graphService.getListUserDemands()
      );
      if (this.demands.length == 0) {
        this.hasNoDemands = true;
      }

      setTimeout(() => {
        this.dataSource = new MatTableDataSource(this.demands);
        this.dataSource.paginator = this.paginator;
      });

      this.isLoading = false;
      this.isErrorGetUsersDemands = false;
      this.errorGetUsersDemands = { error: { message: '', code: '' } };
    } catch (error) {
      let customError: Error = { error: undefined };

      if (error.statusText == 'Unknown Error') {
        customError = { error: { message: 'Unknown Error', code: 'ERR2' } };
      } else {
        if (error.error) {
          customError = error.error;
        }
        if (customError.error !== undefined) {
          if (customError.error.code == 'ERR403') {
            this._router.navigate(['/errors/error-403']);
          } else {
            this._router.navigate(['/errors/error-404']);
          }
        }
      }

      this.isLoading = false;
      this.errorGetUsersDemands = customError;
      this.isErrorGetUsersDemands = true;
    }
  }

  sortData(sort: Sort) {
    this.sortedValue = sort.active;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }

    if (!sort.active || sort.direction === '') {
      this.sortedValue = null;
      return;
    }

    this.dataSource.data = this.dataSource.data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'gender':
          return this.compare(
            a.gender.toLocaleLowerCase(),
            b.gender.toLocaleLowerCase(),
            isAsc
          );
        case 'firstname':
          return this.compare(
            a.firstname.toLocaleLowerCase(),
            b.firstname.toLocaleLowerCase(),
            isAsc
          );
        case 'lastname':
          return this.compare(
            a.lastname.toLocaleLowerCase(),
            b.lastname.toLocaleLowerCase(),
            isAsc
          );
      }
    });
  }

  private compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  toggleRow(element: UserListfields): void {
    this.expandedElement = this.expandedElement === element ? null : element;
  }
}
